module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><g><path fill=\"#27225D\" d=\"M0,0v17.008h17.008V0H0z M15.63,15.629H1.378V1.378H15.63V15.629z\"></path><circle fill=\"#27225D\" cx=\"8.504\" cy=\"4.949\" r=\"2.377\"></circle><path fill=\"#27225D\" d=\"M8.519,7.326c-3.211,0-3.765,3.41-3.765,6.903h7.529C12.283,10.736,11.729,7.326,8.519,7.326z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/personeninfo-anzeigen.svg
// module id = 868
// module chunks = 1